module.exports = __webpack_public_path__ + "static/media/down-arrow.0b9eed77.svg";